/**
 * Per-page SEO metadata - one source of truth. Every public route should
 * pull its title/description/keywords from here so we don't have to hunt
 * through components to update copy for Google.
 *
 * Titles use the pattern "{Page} | Outlaw Media - Ryan Naumenko" so any
 * search containing "Outlaw Media" OR "Ryan Naumenko" has strong ranking
 * signals from the <title> tag.
 */
import { SOCIAL_CARD } from './brand';

const BASE = 'https://www.outlawmedia.com.au';
const DEFAULT_IMAGE = SOCIAL_CARD;

const meta = (path, title, description, keywords = []) => ({
  title,
  description,
  canonical: `${BASE}${path}`,
  image: DEFAULT_IMAGE,
  type: 'website',
  keywords,
});

export const PAGE_SEO = {
  home: meta(
    '/',
    'Outlaw Media | Ryan Naumenko - Melbourne & Australian Crime News',
    "Independent crime news by Ryan Naumenko. Exclusive gangland investigations, tobacco wars, organised crime and Melbourne underworld reporting the mainstream won't touch.",
    ['Outlaw Media', 'Ryan Naumenko', 'Melbourne crime news', 'gangland Melbourne', 'Australian crime news', 'tobacco wars', 'Kaz Hamad'],
  ),
  stories: meta(
    '/stories',
    'Investigations | Outlaw Media - Ryan Naumenko',
    'Every published investigation, exclusive and breaking story from Outlaw Media and Ryan Naumenko - Melbourne underworld, gangland conflicts, organised crime.',
    ['Outlaw Media investigations', 'Ryan Naumenko articles', 'Melbourne gangland stories', 'exclusive crime reports Australia'],
  ),
  explicit: meta(
    '/explicit',
    '18+ Explicit Gangland Videos | Outlaw Media',
    "Explicit gangland video footage from Australia's underworld - reported by Outlaw Media & Ryan Naumenko. Age-restricted, unfiltered, uncensored.",
    ['gangland video', 'Melbourne underworld footage', 'Outlaw Media video', '18+ crime footage'],
  ),
  ganglandcards: meta(
    '/ganglandcards',
    'The Gangland Collection - Melbourne Trading Cards | Outlaw Media',
    "World-first Pokémon-style Melbourne gangland trading cards. Only 1,000 packs. Ryan Naumenko + Outlaw Media Series 1 launch.",
    ['Gangland trading cards', 'Melbourne gangland cards', 'Outlaw Media cards', 'Kaz Hamad card', 'Ryan Naumenko cards'],
  ),
  tip: meta(
    '/tip',
    'Submit an Anonymous Tip | Outlaw Media - Ryan Naumenko',
    "Send Ryan Naumenko and the Outlaw Media team a secure, anonymous tip. Photos, videos, documents - end-to-end encrypted intake.",
    ['submit crime tip', 'anonymous tip Melbourne', 'Ryan Naumenko tip', 'Outlaw Media tip line'],
  ),
  wall: meta(
    '/the-rumour-file',
    'The Rumour File | Outlaw Media - Ryan Naumenko',
    "The Rumour File - anonymous rumours filed to Outlaw Media by the public. SOME names and locations are manually redacted for security purposes. Dedicated to the memory of Derryn Hinch (1944-2026).",
    ['The Rumour File', 'Derryn Hinch', 'anonymous tips Melbourne', 'Ryan Naumenko', 'Outlaw Media'],
  ),
  map: meta(
    '/ganglandmap',
    'Melbourne Gangland Map | Outlaw Media',
    "Live map of gangland incidents, firebombings, shootings and underworld events across Melbourne - mapped from Outlaw Media's own investigations by Ryan Naumenko.",
    ['Melbourne gangland map', 'Melbourne crime map', 'firebombing Melbourne', 'crime hotspots Melbourne', 'Ryan Naumenko'],
  ),
  about: meta(
    '/about',
    'About Outlaw Media & Ryan Naumenko',
    "Meet Ryan Naumenko, founder of Outlaw Media - Australia's leading independent crime journalist. The story, the mission, and the reporting the mainstream media avoids.",
    ['Ryan Naumenko', 'Ryan Naumenko journalist', 'Ryan Naumenko biography', 'about Outlaw Media', 'independent crime journalist Melbourne'],
  ),
  press: meta(
    '/press',
    'Press Kit | Outlaw Media - Ryan Naumenko',
    "Media enquiries, brand assets, bio, and interview requests for Ryan Naumenko and Outlaw Media.",
    ['Ryan Naumenko press', 'Outlaw Media press kit', 'media enquiries Melbourne journalist'],
  ),
  merch: meta(
    '/merch',
    'Merch | Outlaw Media Store',
    'Official Outlaw Media merchandise and the Gangland Collection Series 1 trading cards.',
    ['Outlaw Media merch', 'Gangland cards', 'Ryan Naumenko merch'],
  ),
  privacy: meta(
    '/privacy',
    'Privacy Policy | Outlaw Media',
    'Outlaw Media privacy policy - how we handle tips, comments, contact and analytics data.',
    ['Outlaw Media privacy'],
  ),
  terms: meta(
    '/terms',
    'Terms of Service | Outlaw Media',
    'Terms of use for outlawmedia.com.au, published by Outlaw Media and Ryan Naumenko.',
    ['Outlaw Media terms'],
  ),
};
